// 장비 상세창(EqpDetailModal)의 탭 구성 - 순수 함수만 모아 둔다(모달 컴포넌트에서 분리해 테스트하기
// 쉽게 하려는 목적).
//
// 배경: 장비관리(관리 모드)와 생산 현황/모니터링 보드(보기 모드)가 같은 모달을 열지만 보여줄 탭이
// 다르다. 탭을 "몇 번째"가 아니라 "무슨 탭인지"(key)로 다루는 이유는, 모드마다 탭 집합과 순서가
// 달라 인덱스 하나가 모드에 따라 전혀 다른 탭을 가리킬 수 있기 때문이다(예: manage 모드의 3번
// 탭은 "가공 프로그램"이지만 view 모드의 3번 탭은 "가공 프로그램"이 아니라 범위 밖).

export const TAB_KEYS = {
  INFO: 'info',
  LOG: 'log',
  PLAN: 'plan',
  PROGRAM: 'program',
  TOOL_DIAG: 'toolDiag',
  MAGAZINE: 'magazine',
  TOOLPATH: 'toolpath',
  DAY_DATA: 'dayData',
};

// 장비관리에서 열 때(관리 모드) - 기존 탭 + 새 "수집 데이터" 탭.
const MANAGE_TAB_ORDER = [
  TAB_KEYS.INFO,
  TAB_KEYS.LOG,
  TAB_KEYS.PLAN,
  TAB_KEYS.PROGRAM,
  TAB_KEYS.TOOL_DIAG,
  TAB_KEYS.MAGAZINE,
  TAB_KEYS.TOOLPATH,
  TAB_KEYS.DAY_DATA,
];

// 생산 현황/모니터링 보드에서 열 때(보기 모드) - 설정류(기본정보/공구 진단)는 뺀다.
const VIEW_TAB_ORDER = [
  TAB_KEYS.TOOLPATH,
  TAB_KEYS.DAY_DATA,
  TAB_KEYS.MAGAZINE,
  TAB_KEYS.PROGRAM,
];

export const MODES = { MANAGE: 'manage', VIEW: 'view' };

/**
 * 모드 + 신규 등록 여부에 따라 보여줄 탭 key 목록.
 * 신규 등록(장비관리에서 "장비 등록")은 아직 eqpUuid 가 없어 기본정보 외 탭은 의미가 없다 -
 * 항상 기본정보 하나만 보여준다. (신규 등록은 항상 manage 모드에서만 일어난다 - 보기 모드는
 * 모니터링 보드에서 "이미 있는" 장비를 열 때만 쓴다.)
 */
export const getTabKeysForMode = (mode, { isNew = false } = {}) => {
  if (isNew) return [TAB_KEYS.INFO];
  return mode === MODES.VIEW ? VIEW_TAB_ORDER : MANAGE_TAB_ORDER;
};

/**
 * 지금 탭 집합(tabKeys) 안에서 처음 보여줄 탭의 인덱스.
 * - initialTabKey 가 주어지고 그 key 가 지금 집합에 있으면 그 탭.
 * - 없으면(모드가 안 맞아 빠진 key 를 줬거나, 애초에 안 줬으면) 집합의 첫 탭(0).
 */
export const resolveInitialTabIndex = (tabKeys, initialTabKey) => {
  if (!initialTabKey) return 0;
  const idx = tabKeys.indexOf(initialTabKey);
  return idx >= 0 ? idx : 0;
};

/**
 * 모니터링 카드처럼 "지금 가동 중인지"를 이미 아는 곳에서, 열자마자 보여줄 탭을 고를 때 쓰는
 * 매핑 - RUNNING 이면 가공 진행, 아니면 수집 데이터(계획: 결정사항 3).
 */
export const initialTabKeyForRunState = (runSt) => (
  runSt === 'RUNNING' ? TAB_KEYS.TOOLPATH : TAB_KEYS.DAY_DATA
);

/**
 * manage 모드에서도 "장비관리" 메뉴 쓰기 권한이 없으면 편집 컨트롤(저장/삭제/기준 설정 등)을
 * 가린다. view 모드는 애초에 편집 컨트롤이 없는 탭 집합이라 늘 false.
 * canManagePermission 은 권한 조회가 아직 안 끝났거나 조회에 실패했을 때 true(기존 동작 유지)로
 * 두는 것을 전제로 한다 - 실제 쓰기는 백엔드가 막아주므로 프런트 표시는 과도하게 깜빡이지 않게 한다.
 */
export const canEditInMode = (mode, canManagePermission) => (
  mode === MODES.MANAGE && canManagePermission !== false
);
